import { ValueGetterParams } from "ag-grid-community";
import { DIMENSION_IDS_DELIMITER } from "epics/collections";
import { generateDoorMap } from "../formulas/formula-helpers";

export const SIMPLE_SUM = ({ factoryOptions, getterParams }) => {
    const {
        metric: { kind },
        deliveryId,
        doors,
    } = factoryOptions;
    const {
        data: { reviewPlan },
    }: ValueGetterParams = getterParams;

    const doorsMap = generateDoorMap(doors);

    let planValueSum = 0;
    if (reviewPlan && kind) {
        Object.keys(reviewPlan).forEach((key) => {
            const reviewPlanItem = reviewPlan[key].struct_value;
            const tokens = key.split(DIMENSION_IDS_DELIMITER);
            let doorKey;
            let deliveryKey;

            if (tokens.length === 3) {
                doorKey = tokens[0];
                deliveryKey = tokens[2];
            } else if (tokens.length > 0) {
                doorKey = tokens[0];
            }

            // Find metric for this item
            if (reviewPlanItem.metrics) {
                for (const metric of reviewPlanItem.metrics) {
                    const metricValue = metric.value?.number_value ?? 0;
                    if (metric.kind === kind) {
                        if (deliveryId && deliveryId === deliveryKey && doorsMap.has(doorKey)) {
                            planValueSum += metricValue;
                        } else if (!deliveryId && doorsMap.has(doorKey)) {
                            planValueSum += metricValue;
                        }
                        break;
                    }
                }
            }
        });
    }

    return planValueSum;
};
